import React from 'react';

import styled from 'styled-components';

import GroupsFiltersActive from './GroupsFiltersActive';
import GroupsFiltersCommunitiesCount from './GroupsFiltersCommunitiesCount';
import GroupsFiltersReset from './GroupsFiltersReset';
import GroupsFiltersType from './GroupsFiltersType';
import GroupsFiltersUsers from './GroupsFiltersUsers';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-right: 10px;
`;

const GroupsFiltersMenu = () => {
  return (
    <Container>
      <GroupsFiltersType />
      <GroupsFiltersActive />
      <GroupsFiltersUsers />
      <GroupsFiltersCommunitiesCount />
      <GroupsFiltersReset />
    </Container>
  );
};

export default GroupsFiltersMenu;
